var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsEmail, IsOptional, IsString, MaxLength } from 'class-validator';
export class UserMetadata {
}
__decorate([
    Type(() => Boolean),
    __metadata("design:type", Boolean)
], UserMetadata.prototype, "subscribeCheck", void 0);
__decorate([
    Type(() => String),
    __metadata("design:type", String)
], UserMetadata.prototype, "source", void 0);
__decorate([
    Type(() => String),
    __metadata("design:type", String)
], UserMetadata.prototype, "signup-url-referer", void 0);
__decorate([
    Type(() => String),
    IsOptional(),
    __metadata("design:type", String)
], UserMetadata.prototype, "offerId", void 0);
export class Auth0LoginUser {
}
__decorate([
    IsString(),
    MaxLength(320),
    IsEmail(),
    __metadata("design:type", String)
], Auth0LoginUser.prototype, "email", void 0);
__decorate([
    IsString(),
    MaxLength(320),
    IsOptional(),
    __metadata("design:type", String)
], Auth0LoginUser.prototype, "given_name", void 0);
__decorate([
    IsString(),
    MaxLength(320),
    IsOptional(),
    __metadata("design:type", String)
], Auth0LoginUser.prototype, "name", void 0);
__decorate([
    IsString(),
    MaxLength(320),
    IsOptional(),
    __metadata("design:type", String)
], Auth0LoginUser.prototype, "family_name", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", UserMetadata)
], Auth0LoginUser.prototype, "user_metadata", void 0);
/**
 * Affected endpoints
 * POST /manfredite
 */
export class ManfrediteCreateRequest {
}
__decorate([
    Expose(),
    Type(() => Auth0LoginUser),
    __metadata("design:type", Auth0LoginUser)
], ManfrediteCreateRequest.prototype, "user", void 0);
//# sourceMappingURL=manfredite-create.request.js.map